/**
 * 定义全局的常量
 */

import {getLh} from "@/utils";

/**
 * 手机号正则验证
 * @type {RegExp}
 */
const mobileReg = /^(1)\d{10}$/
const isBoolean = [
  {
    label: '是',
    value: true
  },
  {
    label: '否',
    value: false
  }
]

const tsfs = [
  {
    label: '邮箱',
    value: 0
  },
  {
    label: '手机',
    value: 1
  },
  {
    label: '邮箱和手机',
    value: 2
  }
]
const isLr = [
  {
    label: '是',
    value: '是'
  },
  {
    label: '否',
    value: '否'
  }
]

const lh = getLh('lh', 200, '号楼')
const dy = getLh('dy', 20, '单元')
const lc = getLh('lc', 50, '层')
const fjh = getLh('fjh', 50, '')
export {
  mobileReg,
  isBoolean,
  tsfs,
  isLr,
  lh,
  dy,
  lc,
  fjh
}



// WEBPACK FOOTER //
// ./src/constants/index.js